import { createAsyncThunk } from '@reduxjs/toolkit';

// Define the asyncThunk for fetching groups from Contentful
export const fetchContentGroupByName = createAsyncThunk(
  'groups/fetchByGroupName',
  async (groupName, { rejectWithValue }) => {
    const SPACE_ID = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
    const ACCESS_TOKEN = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;
    const url = `https://cdn.contentful.com/spaces/${SPACE_ID}/environments/master/entries?content_type=${groupName}`;

    try {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${ACCESS_TOKEN}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch data from Contentful');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchContentEntryById = createAsyncThunk(
  'content/fetchById',
  async (contentId, { getState, rejectWithValue }) => {
    const SPACE_ID = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
    const ACCESS_TOKEN = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;
    const url = `https://cdn.contentful.com/spaces/${SPACE_ID}/environments/master/entries/${contentId}`;
    const state = getState().contentGroups;

    // Check if entry already exists in state
    if (state.entries[contentId]) {
      return state.entries[contentId]; // Return the existing entry data
    }

    try {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${ACCESS_TOKEN}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch content entry from Contentful');
      }

      const data = await response.json();
      return data.fields; // Return only the 'fields' for ease of use
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const fetchEntriesByFieldValue = createAsyncThunk(
  'content/fetchByFieldValue',
  async ({ contentType, fieldName, fieldValue }, { rejectWithValue }) => {
    const SPACE_ID = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
    const ACCESS_TOKEN = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;

    // Construct URL with query parameters for field matching
    const url = `https://cdn.contentful.com/spaces/${SPACE_ID}/environments/master/entries?content_type=${contentType}&fields.${fieldName}=${fieldValue}`;

    try {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${ACCESS_TOKEN}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch entries from Contentful');
      }

      const data = await response.json();
      return data.items; // Returns array of matching entries
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
